import React from "react";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/app/ui-bits";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import ProjectRiskIssueChange from "@/components/app/ProjectRiskIssueChange";
import { GitBranch, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function CRQAPanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/change-requests?project_id=${project.id}`, [project.id]);
  return (
    <div data-testid={`panel-crqa-${project.id}`}>
      <PanelHeader icon={GitBranch} title="Change Requests · QA" subtitle="F-PM-07 · scope/schedule/cost changes"
        action={<ProjectRiskIssueChange project={project} trigger={<Button size="sm" variant="outline">Manage <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No change requests on this project." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 20).map((r) => (
            <li key={r.id}
                onClick={() => inspector.open(r, { title: r.title || r.cr_number || "Change Request", subtitle: `${r.impact_type || "—"} · ${r.status || "—"}` })}
                data-testid={`cr-row-${r.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500 w-24 truncate">{r.cr_number || "CR"}</span>
              <span className="min-w-0 flex-1 truncate">{r.title || "Untitled CR"}</span>
              <StatusBadge status={r.status} />
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
